import React, { Component } from 'react';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import ReactApexChart from 'react-apexcharts';
import RiskPagination from '../../risk/RiskPagination';

class TableIndexWeb extends Component {
    constructor(props) {
        super(props);
        this.state = { page: 1, perPage: 10 };
    }

    // Gráfica de barras con la última calificación (%) por requisito.
    // Datos: normativity.normativity_scores[0].score (0-10) -> *10 = %.
    getChartConfig = () => {
        const data = this.props.data || [];
        const categories = data.map(n => n.name || '—');
        const values = data.map(n => {
            const scores = n.normativity_scores || [];
            return scores.length > 0 ? Number((scores[0].score * 10).toFixed(1)) : 0;
        });
        const colors = data.map(n => {
            const scores = n.normativity_scores || [];
            if (scores.length === 0) return '#94a3b8';        // sin calificación
            const s = scores[0].score;
            if (s < 6) return '#ea7470';                       // rojo
            if (s < 8) return '#ffa600';                       // naranja
            return '#22c488';                                  // verde
        });
        const title = this.props.getNameTitle
            ? `Gestión de normatividad para ${this.props.getNameTitle(this.props.type)}`
            : 'Gestión de normatividad';

        return {
            series: [{ name: 'Última calificación', data: values }],
            options: {
                chart: { type: 'bar', height: 340, fontFamily: 'inherit', toolbar: { show: true } },
                plotOptions: {
                    bar: { borderRadius: 8, distributed: true, columnWidth: '55%', dataLabels: { position: 'top' } },
                },
                colors,
                legend: { show: false },
                dataLabels: {
                    enabled: true,
                    formatter: v => v + '%',
                    offsetY: -20,
                    style: { colors: ['#64748b'], fontWeight: 600, fontSize: '12px' },
                },
                xaxis: {
                    categories,
                    labels: { rotate: -35, trim: true, style: { fontSize: '11px', colors: '#64748b' } },
                    axisBorder: { color: '#e2e8f0' },
                    axisTicks: { color: '#e2e8f0' },
                },
                yaxis: {
                    min: 0, max: 100, tickAmount: 5,
                    labels: { formatter: v => v + '%', style: { colors: '#94a3b8' } },
                },
                grid: { borderColor: '#eef0f3', strokeDashArray: 4 },
                tooltip: { y: { formatter: v => v + '%' } },
                title: {
                    text: title, align: 'center',
                    style: { fontSize: '15px', fontWeight: 700, color: '#0f172a' },
                },
            },
        };
    }

    render() {
        const { type, estados, id, formUpdate } = this.props;
        const isNNOM = type == "NNOM";
        const data = this.props.data || [];
        const total = data.length;
        const totalPages = Math.max(1, Math.ceil(total / this.state.perPage));
        const page = Math.min(this.state.page, totalPages);
        const pageData = data.slice((page - 1) * this.state.perPage, page * this.state.perPage);

        // Nº de columnas (para el colSpan del empty state)
        let colCount = 2; // # + Nombre
        if (!isNNOM) colCount += 3;          // Última calificación + Evaluaciones + Estándares y guías
        if (isNNOM) colCount += 3;           // Fecha + Calificación + Archivos
        colCount += 1;                        // Acciones

        return (
            <div className="rk-wrap">
                <div className="rk-table-card">
                    <div className="rk-table-scroll">
                        <table className="rk-table">
                            <thead>
                                <tr>
                                    <th className="rk-table__num">#</th>
                                    <th>Nombre</th>
                                    {!isNNOM && <th className="text-center">Última calificación</th>}
                                    {isNNOM && <th className="text-center">Fecha de calificación</th>}
                                    {isNNOM && <th className="text-center">Calificación</th>}
                                    {isNNOM && <th className="text-center">Archivos</th>}
                                    {!isNNOM && <th className="text-center">Evaluaciones</th>}
                                    {!isNNOM && <th className="text-center">Estándares y guías</th>}
                                    <th className="rk-table__actions"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {total >= 1 ? (
                                    pageData.map((normativity, i) => {
                                        const editing = normativity.id == id;
                                        return (
                                            <tr key={normativity.id}>
                                                <td className="rk-table__num">{(page - 1) * this.state.perPage + i + 1}</td>

                                                {/* Nombre (editable inline) */}
                                                <td className="rk-cell-primary">
                                                    {editing ? (
                                                        <input
                                                            type="text"
                                                            name="name"
                                                            value={formUpdate.name}
                                                            onChange={this.props.HandleChangeUpdate}
                                                            className="rk-input rk-input--inline"
                                                        />
                                                    ) : (
                                                        normativity.name || '—'
                                                    )}
                                                </td>

                                                {/* Última calificación (no NNOM) */}
                                                {!isNNOM && (
                                                    <td className="text-center">
                                                        {this.props.getScore(normativity.normativity_scores)}
                                                    </td>
                                                )}

                                                {/* NNOM: fecha inline */}
                                                {isNNOM && (
                                                    <td className="text-center rk-cell-muted">
                                                        {editing ? (
                                                            <input
                                                                type="date"
                                                                name="date_score"
                                                                value={formUpdate.date_score}
                                                                onChange={this.props.HandleChangeUpdate}
                                                                className="rk-input rk-input--inline"
                                                            />
                                                        ) : (
                                                            normativity.date_score || '—'
                                                        )}
                                                    </td>
                                                )}

                                                {/* NNOM: calificación inline */}
                                                {isNNOM && (
                                                    <td className="text-center">
                                                        {editing ? (
                                                            <input
                                                                type="number"
                                                                name="score"
                                                                value={formUpdate.score}
                                                                onChange={this.props.HandleChangeUpdate}
                                                                placeholder="Calificación"
                                                                className="rk-input rk-input--inline"
                                                            />
                                                        ) : (
                                                            <span className={this.props.getColor ? this.props.getColor(normativity.score) : ''}>
                                                                {normativity.score != null ? normativity.score : '—'}
                                                            </span>
                                                        )}
                                                    </td>
                                                )}

                                                {/* NNOM: archivos */}
                                                {isNNOM && (
                                                    <td className="text-center">
                                                        <button
                                                            className="rk-inline-btn"
                                                            onClick={() => this.props.addFiles(normativity)}
                                                        >
                                                            <i className="fas fa-paperclip"></i> Archivos
                                                        </button>
                                                    </td>
                                                )}

                                                {/* Evaluaciones (no NNOM) */}
                                                {!isNNOM && (
                                                    <td className="text-center">
                                                        {estados.evaluations && (
                                                            <a
                                                                className="rk-link-btn"
                                                                data-turbolinks="true"
                                                                href={`/health/normativity/${normativity.id}`}
                                                            >
                                                                <i className="fas fa-chart-line"></i> Evaluaciones
                                                            </a>
                                                        )}
                                                    </td>
                                                )}

                                                {/* Estándares y guías (no NNOM) */}
                                                {!isNNOM && (
                                                    <td className="text-center">
                                                        <a
                                                            className="rk-link-btn"
                                                            data-turbolinks="true"
                                                            href={`/health/normativity/${normativity.id}/numeral_parents`}
                                                        >
                                                            <i className="fas fa-list-ul"></i> Estándares y guías
                                                        </a>
                                                    </td>
                                                )}

                                                {/* Acciones */}
                                                <td className="rk-table__actions">
                                                    {editing ? (
                                                        <span className="rk-inline-actions">
                                                            <button
                                                                className="rk-icon-btn rk-icon-btn--ok"
                                                                title="Guardar"
                                                                onClick={() => this.props.HandleClickUpdate()}
                                                            >
                                                                <i className="fas fa-check"></i>
                                                            </button>
                                                            <button
                                                                className="rk-icon-btn rk-icon-btn--cancel"
                                                                title="Cancelar"
                                                                onClick={() => this.props.updateId()}
                                                            >
                                                                <i className="fas fa-times"></i>
                                                            </button>
                                                        </span>
                                                    ) : (
                                                        <UncontrolledDropdown>
                                                            <DropdownToggle tag="button" className="rk-icon-btn">
                                                                <i className="fas fa-ellipsis-v"></i>
                                                            </DropdownToggle>
                                                            <DropdownMenu right className="rk-menu">
                                                                {!isNNOM && (
                                                                    <DropdownItem
                                                                        href={`/health/normativity/${normativity.id}/numeral_parents`}
                                                                        data-turbolinks="true"
                                                                    >
                                                                        <i className="fas fa-cog"></i> Gestionar
                                                                    </DropdownItem>
                                                                )}
                                                                {estados.editar && (
                                                                    <DropdownItem onClick={() => this.props.edit(normativity)}>
                                                                        <i className="fas fa-pen"></i> Editar
                                                                    </DropdownItem>
                                                                )}
                                                                {estados.eliminar && (
                                                                    <DropdownItem
                                                                        className="rk-danger"
                                                                        onClick={() => this.props.delete(normativity.id)}
                                                                    >
                                                                        <i className="fas fa-trash"></i> Eliminar
                                                                    </DropdownItem>
                                                                )}
                                                            </DropdownMenu>
                                                        </UncontrolledDropdown>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan={colCount}>
                                            <div className="rk-empty">
                                                <i className="far fa-folder-open"></i>
                                                <p>No hay registros</p>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <RiskPagination
                        page={page}
                        perPage={this.state.perPage}
                        total={total}
                        onPage={(p) => this.setState({ page: p })}
                        onPerPage={(n) => this.setState({ perPage: n, page: 1 })}
                    />
                </div>

                {/* Gráfica de última calificación por requisito (no aplica a NNOM) */}
                {!isNNOM && total > 0 && (
                    <div className="rk-table-card" style={{ marginTop: 16, padding: '14px 10px 6px' }}>
                        <ReactApexChart
                            options={this.getChartConfig().options}
                            series={this.getChartConfig().series}
                            type="bar"
                            height={340}
                        />
                    </div>
                )}
            </div>
        );
    }
}

export default TableIndexWeb;
